import React, { Dispatch, SetStateAction } from "react";
import { SocialProfile } from "src/app/modals/AddSocialProfilesModal/AddSocialProfilesModal";
import { ProfileData } from "src/types/social-data/profileData";
import { API_URLS } from "src/utils/API_URLS";
import { Gallery } from "../Gallery/Gallery";
import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";

interface Props {
  socialProfiles: SocialProfile[];
  showMore: boolean;
  setShowMore: Dispatch<SetStateAction<boolean>>;
  profileData: ProfileData | null;
}

export const PublicationsStream = (props: Props) => {
  const { socialProfiles, showMore, setShowMore, profileData } = props;

  return (
    <Gallery
      config={{
        infiniteScroll: {
          url: API_URLS.getCreatorPublications,
          socialProfiles,
        },
      }}
      header={{
        title: (
          <IDHFormattedMessage
            id="ws_publications"
            defaultMessage="Publications"
          />
        ),
      }}
      showMore={showMore}
      setShowMore={setShowMore}
      creatorData={{
        username: profileData?.user_data?.username || "",
        profilePictureUrl: profileData?.user_data?.profilePictureUrl,
      }}
      enableFilters
      enableSortBy
    />
  );
};
